import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)

// 获取本周
export const getWeekDateRange = function (dataformat = 'YYYY-MM-DD') {
  const start = new Date()
  const end = new Date()
  const nows = start.getDay() || 7 // 注意周日算第一天，如果周日查询本周的话，天数是0，所有如果是0，默认设置为7
  start.setTime(start.getTime() - 3600 * 1000 * 24 * (nows - 1))
  return [dayjs(start).format(dataformat), dayjs(end).format(dataformat)]
}

// 获取当天时间
export const getCurrentDateRange = function () {
  const end = new Date()
  const start = new Date()
  start.setTime(start.getTime())
  end.setTime(end.getTime())
  return [start, end]
}
// 获取昨天时间
export const getYesterdayRange = function () {
  const end = new Date()
  const start = new Date()
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
  end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
  return [start, end]
}
// 获取过去七天
export const getLastSevenDaysRange = function () {
  const start = new Date()
  const end = new Date()
  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
  end.setTime(end.getTime() - 3600 * 1000 * 24)
  return [start, end]
}

// 获取未来n天时间 包含今天
export const getFutureDaysRange = function (n) {
  const day = (n - 1) > 0 ? (n - 1) : 1
  const start = new Date()
  const end = new Date()
  start.setTime(start.getTime())
  end.setTime(end.getTime() + 3600 * 1000 * 24 * day)
  return [start, end]
}

/**
 * @description 是否为同一周
 * @param {*} begin_date
 * @param {*} end_date
 */
export const isSameWeek = (begin_date, end_date) => {
  if (begin_date === end_date) return true
  const date = new Date(begin_date)
  // 本周第一天
  const startTime = new Date(new Date(date).getTime() - (3600 * 1000 * 24 * (new Date(date).getDay() == 0 ? 6 : new Date(date).getDay() - 1)))
  // 本周最后一天
  const endTime = new Date(new Date(date).getTime() + (3600 * 1000 * 24 * (new Date(date).getDay() == 0 ? 0 : 7 - new Date(date).getDay(date))))
  // 如果开始时间 >= 本周第一天 并且小于最后一天
  // 如果结束时间 <= 本周最后一天 并且大于第一天
  const beginDateTime = new Date(begin_date).getTime()
  const endDateTime = new Date(end_date).getTime()
  const weekBeginDateTime = new Date(startTime).getTime()
  const weekEndDateTime = new Date(endTime).getTime()
  if (beginDateTime >= weekBeginDateTime && beginDateTime < weekEndDateTime && endDateTime <= weekEndDateTime && endDateTime > weekBeginDateTime) return true
  return false
}


/** 计算两个时间之间的差距 单位 天 */
export function getDaysBetweenDates(date1, date2) {
  // 使用 Day.js 的 diff 函数计算相差的天数
  const diffDays = dayjs(date2, 'YYYY-MM-DD').diff(dayjs(date1, 'YYYY-MM-DD'), 'day')
  return diffDays
}
